import i18n from '@/i18n';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    username: string;
    role: string;
  };
}

export const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
  console.log('[API] Login API call:', credentials, 'URL:', `${API_URL}/auth/login`);
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });

    console.log('[API] Login response:', response.status, response.statusText);

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[API] Login error:', errorData);
      throw new Error(errorData.error || i18n.t('common:errors.loginFailed'));
    }

    const data = await response.json();
    console.log('[API] Login successful:', data);
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    throw new Error(i18n.t('common:errors.loginFailed'));
  }
};

export const logout = async (): Promise<void> => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      // Make API request using fetchWithAuth
      const response = await fetch(`${API_URL}/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      // Check response status code
      if (!response.ok && response.status !== 404) {
        console.error('Logout failed with status:', response.status);
      }
    }
  } catch (error) {
    console.error('Logout error:', error);
    // Even if an error occurs, the token is removed from local storage
  }
};

export const checkAuth = async (): Promise<boolean> => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }

    const response = await fetch(`${API_URL}/auth/verify`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    return response.status === 200;
  } catch (error) {
    return false;
  }
};
